module.exports = __webpack_public_path__ + "static/media/strikethrough.5d8d5ead.svg";